// extracted by mini-css-extract-plugin
module.exports = {"insightModal":"Theme_insightModal__2OiD5","modalBody":"Theme_modalBody__k91K_"};